import React, { MouseEvent, useCallback } from "react";

import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Paragraph from "antd/es/typography/Paragraph";

import Announcement from "@mapmycustomers/shared/types/announcements/Announcement";
import { Button } from "@mapmycustomers/ui";

import getAnnouncementCta from "@app/util/announcements/getAnnouncementCta";
import getAnnouncementCtaHref from "@app/util/announcements/getAnnouncementCtaHref";

import styles from "./AnnouncementCtaButton.module.scss";

const MIDDLE_MOUSE_BUTTON = 1;

interface AnnouncementCtaButtonProps {
  announcement: Announcement;
  onClick: (announcement: Announcement) => void;
}

const AnnouncementCtaButton = ({ announcement, onClick }: AnnouncementCtaButtonProps) => {
  const handleClick = useCallback(() => onClick(announcement), [announcement, onClick]);
  // A middle click opens the tab too, but fires auxclick instead of click.
  const handleAuxClick = useCallback(
    (event: MouseEvent) => {
      if (event.button === MIDDLE_MOUSE_BUTTON) {
        onClick(announcement);
      }
    },
    [announcement, onClick]
  );

  const cta = getAnnouncementCta(announcement);
  const ctaHref = cta ? getAnnouncementCtaHref(cta) : undefined;

  if (!cta || !ctaHref) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Button
        className={styles.button}
        href={ctaHref}
        onAuxClick={handleAuxClick}
        onClick={handleClick}
        rel="noopener noreferrer"
        rightIcon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
        size="large"
        target="_blank"
        type="primary"
      >
        <Paragraph className={styles.label} ellipsis={{ rows: 1, tooltip: true }}>
          {cta.label}
        </Paragraph>
      </Button>
    </div>
  );
};

export default AnnouncementCtaButton;
